export const complexityConstants = {
  maxComplexity: 5000000 * 0.7,
  createComplexity: 30000,
  webhookComplexity: 20000,
};
